import request, { appendApiUrl } from '@/utils/request'
import { fixSource } from '@/utils/request_helper'
import { deleteEmpty } from './common.js'

// 查询弹框接口
export const getPopup = (options = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/popups/query'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
    }
  )
}

// 根据id查询弹框接口
export const getPopupById = (options = {}) => {
  options = fixSource(options)

  let { popupId, country, deviceType, source = '' } = options
  let params = source
    ? `?deviceType=${deviceType}&source=${source}`
    : `?deviceType=${deviceType}`

  return request.get(
    {
      url: appendApiUrl(`/popups/query/${popupId}/${country}${params}`),
    },
    {
      showLoading: false,
    }
  )
}
